/**
 * Note: properties starting with a '_' are removed before sending
 *
 * @module app.model
 * @license Copyright 2013 (c) RISE Ges.m.b.H.
 *  ____   ___  ____   _____
 * |  _ \  | | / ___| | ____|
 * | |_) | | | \___ \ |  _|
 * |  _ <  | |  ___) || |___
 * |_| \_\ |_| |____/ |_____|
 *
 */
(function(app) {
    "use strict";

    // Models _need_ to be a function with a name (NOT an anonymous function!)
    app.model.EventLogbookEntry = function EventLogbookEntry(json) {
        var obj = (typeof json === 'string') ? JSON.parse(json) : json;

        if (!obj) {
            obj = {};
        }

        // set entry type
        obj.entry_type      = app.model.LogbookEntryType.EVENT;

        this.event_type_id  = obj.event_type_id != null ? parseInt(obj.event_type_id) : null;
        this.object_id      = obj.object_id != null ? parseInt(obj.object_id) : null;
        this.workplace_id   = obj.workplace_id != null ? parseInt(obj.workplace_id) : null;
        this.sent_email_to  = obj.sent_email_to != null ? obj.sent_email_to : null;

        this.documents   = _.map(obj.documents || [], function(document) {
            return new app.model.Document(document);
        });

        this.event_fields   = _.map(obj.event_fields || [], function(event_field) {
            return new app.model.EventField(event_field);
        });

        // if model was invoked directly, add also add the LogbookEntry fields
        app.model.LogbookEntry.apply(this, [obj]);
    };

}(window.app));
